// Field-unit helpers for the grid-to-coordinate field map.
// Field space is 100 (width) x 80 (height) units, origin (0,0) at bottom-left.
// See PRD-Grid-to-Coordinate-System.md section 6.1.
//
// Pixel <-> field-unit conversion itself is handled by the Konva Stage's
// scale/position transform (see FieldMapV2.js) via getRelativePointerPosition,
// so this file only keeps the pure field-space math.

export const FIELD_WIDTH_UNITS = 100;
export const FIELD_HEIGHT_UNITS = 80;
export const GRID_COLS = 10;
export const GRID_ROWS = 8;

export const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

// Maps a field-unit coordinate to the existing 1-80 cell numbering
// (row 0 = bottom, col 0 = left), matching PositionLayedMap's formula.
export const fieldToCell = (x, y) => {
  const col = clamp(Math.floor(x / (FIELD_WIDTH_UNITS / GRID_COLS)), 0, GRID_COLS - 1);
  const row = clamp(Math.floor(y / (FIELD_HEIGHT_UNITS / GRID_ROWS)), 0, GRID_ROWS - 1);
  return row * GRID_COLS + col + 1;
};

export const roundField = ({ x, y }) => ({
  x: Math.round(clamp(x, 0, FIELD_WIDTH_UNITS)),
  y: Math.round(clamp(y, 0, FIELD_HEIGHT_UNITS)),
});

// Field-unit bounding box (x, y = bottom-left corner, field-y-up) of a 1-80 cell.
export const cellBounds = (cell) => {
  const idx = clamp(cell, 1, GRID_COLS * GRID_ROWS) - 1;
  const row = Math.floor(idx / GRID_COLS);
  const col = idx % GRID_COLS;
  const width = FIELD_WIDTH_UNITS / GRID_COLS;
  const height = FIELD_HEIGHT_UNITS / GRID_ROWS;
  return { x: col * width, y: row * height, width, height };
};
